import * as Icons from "lucide-react";
import React from "react";

const ServiceIcon = ({ name, className = "", size = 22 }) => {
    const Cmp = Icons[name] || Icons.Sparkles;
    return <Cmp className={className} size={size} />;
};

export default ServiceIcon;
